/**
 *    @author: Andrew Sheen
 *    @since:  2021-01-30
 */

 import { Injectable } from '@angular/core';
 import {HttpClient} from "@angular/common/http";
 import { environment } from '../../environments/environment';
 import { MailAddressChoice } from 'src/app/_common/data/lookup-data';
 
 @Injectable({
   providedIn: 'root',
 })
 
 
 
 export class PostalCodeLookup {
 
        constructor(private http:HttpClient)  {
 
        }
 
        public lookup(code:string, callback:Function ) {
         
             let url = environment.postalCode_url + code;
 
             if ( environment.production == false ) {
                   
                  if ( "G2G2G2" == code || "g2g2g2" == code ) {
                        url = "assets/i18n/test.lookup1.json";
                  }
                  else
                  if ( "H2H2H2" == code ) {
                        url = "assets/i18n/test.lookup.json";
                  }
             }
 
             this.http.get(url)
                 .subscribe( (res:MailAddressChoice[]) => {
                       callback(res);
             },
             error => {
                   ///console.log("error:"+error);
                   callback(null);
             });
              
 /* 
   postalCode1_url: 'assets/i18n/test.lookup1.json'
 
 */        
 }
 }
 